import { IExtendedContext } from '../../../types/extendedContext';
import { resetState } from '../../../../shared/ServicePickerWidget/actions/resetState';

export const resetStateHandler = (context: IExtendedContext) => () => {
  context.store.dispatch(resetState());
};
